import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { OverlayComponent } from '../overlay/overlay.component';
import { OverlayOriginDirective } from '../overlay/overlay-origin.directive';
import { OverlayToggleDirective } from '../overlay/overlay-toggle.directive';
import { ServicesModule } from '../../services/services.module';
import { PipesModule } from '../../pipes/pipes.module';
import { IconButtonComponent } from '../icon-button/icon-button.component';

import { BottomModalComponent } from '../bottom-modal/bottom-modal.component';
import { FocusDirective } from '../focus/focus.directive';
import { FocusOnDisabledDirective } from '../focus/focus-on-disabled.directive';

import { DatePickerComponent } from './date-picker/date-picker.component';
import { DatePickerService } from './date-picker/date-picker.service';
import { DatePickerInnerComponent } from './date-picker-inner/date-picker-inner.component';
import { DatePickerConfig } from './date-picker/date-picker.config';
import { DayPickerComponent } from './day-picker/day-picker.component';
import { MonthPickerComponent } from './month-picker/month-picker.component';
import { YearPickerComponent } from './year-picker/year-picker.component';
import { RangeSelectorCalendarComponent } from './range-selector-calendar/range-selector-calendar.component';
import { RangeSelectorCalendarConfig } from './range-selector-calendar/range-selector-calendar.config';
import { DatePickerButtonComponent } from './date-picker-button/date-picker-button.component';
import { DatePickerToggleComponent } from './date-picker-toggle/date-picker-toggle.component';
import { DatePickerInputDirective } from './date-picker/date-picker-input.directive';
import { RangeSelectorCalendarInputDirective } from './range-selector-calendar/range-selector-calendar-input.directive';
import { SlideDatePickerComponent } from './date-picker/slide-date-picker.component';
import { SlideDatePickerToggleComponent } from './date-picker-toggle/slide-date-picker-toggle.component';
import { DualMonthDayPickerComponent } from './dual-month-day-picker/dual-month-day-picker.component';

@NgModule({
  imports: [
    BottomModalComponent,
    IconButtonComponent,
    FocusDirective,
    FocusOnDisabledDirective,
    CommonModule,
    OverlayComponent,
    OverlayOriginDirective,
    OverlayToggleDirective,
    PipesModule,
    FormsModule,
    ReactiveFormsModule,
    ServicesModule,
    DatePickerComponent,
    DatePickerInnerComponent,
    DayPickerComponent,
    DatePickerButtonComponent,
    MonthPickerComponent,
    YearPickerComponent,
    RangeSelectorCalendarComponent,
    DatePickerToggleComponent,
    DatePickerInputDirective,
    RangeSelectorCalendarInputDirective,
    SlideDatePickerComponent,
    SlideDatePickerToggleComponent,
    DualMonthDayPickerComponent
  ],
  exports: [
    DatePickerComponent,
    DatePickerToggleComponent,
    RangeSelectorCalendarComponent,
    DatePickerInputDirective,
    RangeSelectorCalendarInputDirective,
    SlideDatePickerComponent,
    SlideDatePickerToggleComponent
  ],
  providers: [
    DatePickerService,
    DatePickerConfig,
    RangeSelectorCalendarConfig
  ]
})
export class DateRangeSelectorModule {
}
